// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Mh2i","colCheckbox":"styles_colCheckbox__Ug5Hh"};